import React, { Component } from 'react';
import { Table, message, Popconfirm, Icon } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import PreviewModal from './PreviewModal';
import AddSSUMember from './AddSSUMember';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import Filter from './Filter';

class Ssu extends Component {
    state = {
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        let obj = {};
        ( searchParams.courtyardArea || [] ).map((item, index) =>{
            obj[`ids[${index}]`] = item
        });
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.querySsuMemberList}`,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                ...obj,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    pagination.total = res.totalCount;
                    this.setState({
                        pagination,
                        loading: false,
                        data: res.datas,
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const url = API_URL.user.exportSsuMemberList;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 80,
    }, {
        title: '工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 80,
        sorter: true,
        sortType: 'common',
    }, {
        title: '姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 80,
    }, {
        title: '职位级别',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 100,
    }, {
        title: '部门',
        dataIndex: 'enterpriseDepartmentName',
        key: 'enterpriseDepartmentName',
        width: 100,
    }, {
        title: '手机号码',
        dataIndex: 'userMobile',
        key: 'userMobile',
        width: 120,
    }, {
        title: '邮箱',
        dataIndex: 'userEmail',
        key: 'userEmail',
        width: 160,
    }, {
        title: '工作城市',
        dataIndex: 'workCity',
        key: 'workCity',
        width: 80,
    }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: 80,
        render: (text) => {
            if (text == 'WORKING') {
                return '在职'
            } else if (text == 'LEFT') {
                return '离职'
            }
        }
    }, {
        title: '主管领导',
        dataIndex: 'leaderName',
        key: 'leaderName',
        width: 80,
    }, {
        title: '主管领导手机号码',
        dataIndex: 'leaderMobile',
        key: 'leaderMobile',
        width: 120,
    }, {
        title: '操作',
        dataIndex: 'option',
        key: 'option',
        width: 120,
        render: (text, record) => {
            const { curRole, userId } = sessionStorage;
            return (
                (record.canEdit && !(curRole == 'VP' || curRole == 'FIN' || curRole == 'BA' || curRole == 'BAL')) ?
                    <span>
                        {
                            (curRole == 'CRC' && userId == record.userId) ?
                                <a disabled={true}>删除</a>
                            :
                                <Popconfirm title='确定要将该人员从SSU通讯录删除?' icon={<Icon type="close-circle-o" style={{ color: 'red' }} />} onConfirm={() => this.delete(record.ssuMemberId)} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                        }
                        <span className="ant-divider" />
                        <a onClick={() => this.showPreviewModal(record)}>负责医院</a>
                    </span>
                :
                    <span>
                        <a onClick={() => this.showPreviewModal(record)}>负责医院</a>
                    </span>
            )
        }
    }]

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;

        const dataSource = [];
        if (data && data.length > 0) {
            data.map((item, index) => {
                dataSource.push({
                    index: (current - 1) * pageSize + index + 1,
                    ...item,
                });
            });
        }
        return dataSource;
    }

    handleTableChange = (pager, filters, sorter) => {
        const { pagination, sortParams } = this.state;
        if (pagination.current == pager.current) {
            pagination.current = 1;
        } else {
            pagination.current = pager.current;
        }
        sortParams.sort = sorter.field || '';
        if (sorter.order) {
            sortParams.direction = sorter.order == 'descend' ? 'DESC' : 'ASC';
        } else {
            sortParams.direction = '';
        }
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    delete = (ssuMemberId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.delSsuMember}`,
            data: { ssuMemberId },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    showPreviewModal = record => {
        this.previewModalRef.show(record);
    }

    addMember = record => {
        this.addSSUMemberRef.show(record);
    }

    render() {
        const { loading, pagination } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='ssu' />
                <div className="main">
                    <Filter search={this.search} export={this.export} addMember={this.addMember} />
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={row => row.ssuMemberId}
                        loading={loading}
                        scroll={{ x: 1200 }}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                </div>
                <PreviewModal ref={el => this.previewModalRef = el } />
                <AddSSUMember ref={el => this.addSSUMemberRef = el } loadData={this.loadData} />
            </div>
        )
    }
}

export default Ssu;


// WEBPACK FOOTER //
// ./src/components/hospital/ssu/index.js